angular.module('aprima-core-ui')
    .directive('apAutoGrow', ['$interval', 'DeviceSettings', function($interval, DeviceSettings) {
    'use strict';

    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, element, attr){

            var minHeight = 34;

            var $shadow = angular.element('<div></div>').css({
                position: 'absolute',
                top: -10000,
                left: -10000,
                font: element.css('font'),
                resize:     'none',
                wordWrap: 'break-word',
                whiteSpace: 'pre-wrap',
                'box-shadow': element.css('box-shadow')
            });
            angular.element(document.body).append($shadow);

            element.css('overflow', 'hidden');
            element.css('resize', 'none');

            // In the event that the canvas get's resized, we want to adjust the size, so we're creating an interval to monitor for changes.
            var widthWatch = $interval(updateShadowDiv, 100);

            var lastWidth = -1;
            function updateShadowDiv() {
                // This method was sometimes causing Protractor to timeout,
                // not accessing the padding properties or calling update unless something changed fixed this. 
                var newWidth = element.innerWidth();
                if (lastWidth === newWidth) {
                    return;
                }

                lastWidth = newWidth;
                if (DeviceSettings.isIos) {
                    newWidth = element.innerWidth() - parseInt(element.css('padding-right') || 0) - parseInt(element.css('padding-left') || 0) - 6;
                }
                else {
                    newWidth = element.innerWidth() - parseInt(element.css('padding-right') || 0) - parseInt(element.css('padding-left') || 0);
                }
                
                $shadow.css('width', newWidth);
                update();
            }

            function update() {
                var val = element.val()
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/&/g, '&amp;')
                .replace(/\n ?$/, '<br/>&nbsp;')
                .replace(/\n/g, '<br/>');

                $shadow.html(val);

                var newHeight = Math.max($shadow[0].offsetHeight + 14, minHeight) + 'px';
                element.css('height', newHeight);
            }

            var modelWatch = scope.$watch(attr.ngModel, update);

            scope.$on('$destroy', function() {
                $interval.cancel(widthWatch);
                modelWatch();
                $shadow.remove();
            });
        }
    };
}]);